export function selectHelpUrl(state) {
    return state.customer.help_url;
}



// WEBPACK FOOTER //
// ./src/selectors/customer.js